
import { Injectable } from '@angular/core';


@Injectable()
export class DoseAndViasCalculationService {
    multiplier = 16;
    decimal;
    Divder2 = 400;
    Divder3 = 100;

    _dose: number;
    _weight: number;
    _vial20ml: number;
    _sobrante: number;
    _val100mg: number;

    dose(weight): any {
        this._weight = weight;
        this._dose = this.multiplier * this._weight;
        this._vial20ml = this.vial20ml();
        this._sobrante = this.sobrante();
        this._val100mg = this.vail100mg();

        const vial = {
            '_weight': this._weight,
            '_dose': this._dose,
            '_vial20ml': this._vial20ml,
            '_sobrante': this._sobrante,
            '_val100mg': this._val100mg
        };
        return vial;
    }

    vial20ml(): number {
        return this.vails400mg(this._dose) + this.vails400mgextra();
    }

    sobrante(): number {
        return ((this.Divder2 * this.vails400mg(this._dose) + (this.Divder3 * this.vail100mg()) - this._dose));
    }

    vail100mg(): number {
        if (this.Divder2 * this.decimal > 300) {
            return 0;
        } else {
            return Math.round((this.Divder2 * this.decimal) / this.Divder3);
        }
    }
    decimalnum() {
        return ((this._dose / this.Divder2) - Math.floor(this._dose / this.Divder2));
    }
    vails400mg(Dse): number {
        const a = Dse / this.Divder2;
        this.decimal = a % 1;
        return Math.floor(a);
    }
    vails400mgextra() {

        if (this.sobrante() < -300) {
            return 1;
        } else {
            return 0;
        }

    }
}
